/**
 * Re-export of tailwind theme colors for use in components.
 * Needed because CRA restricts imports outside src/.
 * Keep in sync with tailwind.config.js theme.colors
 */
export const themeColors = {
  "ai-assist-background": "#015970",
  white: "#FFFFFF",
  "portfolio-blue": "#026F8A",
} as const;
